"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _client = require("react-dom/client");
/**
 * Render the component in the DOM.
 *
 * @param {Component} component The component to render on the page.
 * @param {Object} config Configuration.
 * @param {Boolean} config.hydrate Hydrate the component only.
 * @param {String} config.selector CSS selector of the root we want to mount.
 * @returns {ReactRoot} The created React Root instance so you can umount at will.
 * @public
 */
function render(component) {
  let {
    selector = '[data-render="header"]',
    hydrate = false,
    onRecoverableError,
    identifierPrefix
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const domNode = document.querySelector(selector);
  const renderMethod = hydrate ? hydrateComponent : renderComponent;
  return renderMethod(domNode, component, {
    onRecoverableError,
    identifierPrefix
  });
}

/**
 * Render the component in the given DOM node.
 *
 * @param {HTMLElement} el The root element where we should render our component.
 * @param {Component} component React Component to render.
 * @param {Object} opts Options for renderer.
 * @returns {ReactRoot} React Root instance.
 * @private
 */
function renderComponent(el, component) {
  let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const root = (0, _client.createRoot)(el, opts);
  root.render(component);
  return root;
}

/**
 * Hydrate the component in the given DOM node.
 *
 * @param {HTMLElement} el The root element where we should render our component.
 * @param {Component} component React Component to render.
 * @param {Object} opts Options for renderer.
 * @returns {ReactRoot} React Root instance.
 * @private
 */
function hydrateComponent(el, component) {
  let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _client.hydrateRoot)(el, component, opts);
}
var _default = render;
exports.default = _default;